/**
 * Devuelve una sola representación de cada elemento persistido.
 *
 * La conversación pinta inmediatamente la respuesta de un alta y, unos
 * instantes después, el refresco de la solicitud devuelve ese mismo registro.
 * La identidad es el id persistido; la copia del servidor prevalece porque
 * contiene las relaciones completas (autor, fechas, etc.).
 */
export const deduplicatePersistedItems = (localItems = [], serverItems = []) => {
  const result = [];
  const positions = new Map();

  const append = (item, replaceExisting) => {
    if (!item || item.id === null || item.id === undefined) {
      if (item) result.push(item);
      return;
    }

    const key = String(item.id);
    if (positions.has(key)) {
      if (replaceExisting) result[positions.get(key)] = item;
      return;
    }

    positions.set(key, result.length);
    result.push(item);
  };

  // Se mantiene el orden que devuelve la API; las altas optimistas que todavía
  // no aparecen en ella se añaden al final. Si ambas contienen el mismo id, la
  // versión del servidor conserva la autoría y las relaciones completas.
  for (const item of serverItems) append(item, true);
  for (const item of localItems) append(item, false);

  return result;
};

/**
 * La API no debería repetir eventos, pero se normaliza también la hoja de
 * ruta para que una respuesta solapada durante el primer render nunca pinte
 * dos veces el mismo estado.
 */
export const deduplicateTimelineEvents = (events = []) =>
  deduplicatePersistedItems([], events);
